import { Component, TemplateRef, Input, Inject } from '@angular/core';
import { IdDescricao } from '@app/models/util/id-descricao';
import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-fluxo-de-caixa-diario-previsao',
  templateUrl: './fluxo-de-caixa-diario-previsao.component.html'
})
export class FluxoDeCaixaDiarioPrevisaoComponent {
  @Input() lstUnidades: IdDescricao[] = [];
  @Input() lstConta: IdDescricao[] = [];
  rel: any;
  relResumo: any;
  filtros: any;
  modalRef: BsModalRef;
  resumoDia: any;
  pesquisando: boolean;
  showTable: boolean;

  dataRelatorio: Date;

  constructor(
    @Inject(ToastrService) private toastr: ToastrService,
    private modalService: BsModalService,
    private relatorioService: RelatorioService
  ) { 
    this.filtros = {
      ContaId: null,
      UnidadeId: '',
      DataInicial: UtilitarioService.retornaDataAtualMaisDiasISO(0),
      DataFinal: UtilitarioService.retornaDataAtualMaisDiasISO(30),
    };
  }

  pesquisar() {
    this.dataRelatorio = new Date();
    this.pesquisando = true;
    this.relatorioService.previsaoFluxoDeCaixaDiario(this.filtros).subscribe(
      relatorio => {
        this.rel = relatorio;
        this.pesquisando = false;

        if (this.rel.Itens.length > 0) {
          this.showTable = true;
        } else {
          this.showTable = false;
          this.toastr.info('Busca não encontrou resultados');
        }
      }, () => {
        this.pesquisando = false;
        this.toastr.error('Realize a pesquisa novamente.');
      });
  }

  public imprimir() {
    let conteudo = document.getElementById("fluxoDeCaixaPrevisao").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, 'Relatório Fluxo de Caixa Diário (PREVISÃO)', this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());

    parseDateAdicionaMap('Data Inicial', this.filtros.DataInicial);
    parseDateAdicionaMap('Data Final', this.filtros.DataFinal);

    obtemDescricaoAdicionaMap('Unidade', this.lstUnidades, this.filtros.UnidadeId);

    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      }
    }

    function parseDateAdicionaMap(tipoData: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }

  resumo(template: TemplateRef<any>, data: any) {
    this.resumoDia = data;
    const filtros = { ...this.filtros };
    filtros.DataInicial = data;
    this.relatorioService.previsaoFluxoDeCaixaDiarioResumo(filtros).subscribe(dados => {
      this.relResumo = dados;
      this.modalRef = this.modalService.show(template, { class: 'modal-lg modal-xl' });
    });
  }
}
